import { runDemo } from "../shared/demoRunner";
import { createProceduralScene } from "./scene";

runDemo({ createScene: createProceduralScene });
